/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./trans-name.vue?vue&type=template&id=6453be9e&scoped=true&"
import script from "./trans-name.vue?vue&type=script&lang=js&"
export * from "./trans-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453be9e",
  null
  
)

export default component.exports